import React from 'react';

import { FormBaseLayout } from 'modules/components/layer10';
import { StyledTextField } from 'modules/components/layer01';

import {
  SelectInstallationAreaField,
  SelectInstallationRoomField,
  SelectInstallationTypeField,
  SelectMilestoneField
} from 'modules/components/layer04';

import * as ds from './dataService';
import { Stack } from '@mui/material';
import { SaveInstallation_Input } from 'generated/graphql';
import _ from 'lodash';
import { DateTime } from 'luxon';

export type SaveInstallationFormProps = {
  id: string;
  projectId?: string;
  handleClose: () => void;
};

export const FC = (props: SaveInstallationFormProps) => {
  const [
    fnSaveForm,
    { loading }
  ] = ds.useSaveInstallation();
  const form = ds.useFormState(props.id, props.projectId ?? '');

  const handleSubmit = async () => {
    let tempFormStateArr = _.entries(form.formState);

    tempFormStateArr = tempFormStateArr.filter((node) => node[0] !== 'connectedToMilestone');

    const tempFormState = tempFormStateArr.reduce((acc, node) => {
      return {
        ...acc,
        [node[0]]: node[1]
      };
    }, {
    });



    const input: SaveInstallation_Input = {
      ...tempFormState,
      durationInDays: _.toNumber(form.formState.durationInDays),
      estimatedStartDate: DateTime.fromFormat(form.formState.estimatedStartDate, 'yyyy-LL-dd'),
      endDate: DateTime.fromFormat(form.formState.endDate, 'yyyy-LL-dd'),
      name: form.formState.name,
      roomName: form.formState.roomName,
      milestoneId: form.formState.connectedToMilestone ? form.formState.milestoneId : null,
      purchaseDate: DateTime.fromFormat(form.formState.purchaseDate, 'yyyy-LL-dd') ?? null,
      startDate: DateTime.fromFormat(form.formState.startDate, 'yyyy-LL-dd')
    };

    const cleanedInput = _.mapValues(input, (node, key: keyof typeof input) => {
      if (key === 'roomName') {
        return node;
      }
      if (node === '' && !typeof 'number') {
        return undefined;
      }
      if (typeof node === 'number') {
        return _.toNumber(node);
      }

      return node;
    });
    await fnSaveForm(cleanedInput);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={async () => {
        await handleSubmit();
        props.handleClose();
      }}
      isLoading={loading}
      cancelButtonText='Cancel'
      successButtonText='Save'
    >
      <Stack
        rowGap='1.5rem'
        width='28rem'
      >
        <StyledTextField.FC
          {...form.genFieldProps('name')}
        />
        <SelectInstallationRoomField.FC
          form={form}
          fieldName='roomName'
        />
        <SelectInstallationAreaField.FC
          form={form}
          fieldName='areaId'
        />
        <SelectInstallationTypeField.FC
          form={form}
          fieldName='installationTypeId'
        />
        <StyledTextField.FC
          {...form.genFieldProps('estimatedStartDate')}
        />
        <StyledTextField.FC
          {...form.genFieldProps('startDate')}
        />
        <StyledTextField.FC
          {...form.genFieldProps('endDate')}
        />
        <StyledTextField.FC
          {...form.genFieldProps('purchaseDate')}
        />

        <SelectMilestoneField.FC
          form={form}
          fieldName='milestoneId'

        />

      </Stack>
    </FormBaseLayout.FC>

  );
};
